import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { MutationOptions } from '@/api/react-query'
import { userPathKey } from '@/helpers'
import { UpdateUserBody } from '@/types'

export async function updateUser(body: UpdateUserBody) {
  const response = await httpClient('user-manager').put(
    `/v1/user/${userPathKey()}`,
    body,
  )

  return response.data
}

export function useUpdateUser(
  options?: MutationOptions<unknown, UpdateUserBody>,
) {
  return useMutation({
    mutationFn: updateUser,
    ...options,
  })
}
